import React from "react";
import { ToastContainer } from "react-toastify";
import { RingLoader } from "react-spinners";
import NavBar from "components/SideBar/SideBar2";
import HeaderBar from "./HeaderBar";
import Table from "./Table";
import { useSelector } from "react-redux";

const EmailMaster = (props) => {
  const loaderStatus = useSelector((state) => state.emailMasterReducer.loaderStatus);
  return (
    <>
      {" "}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnVisibilityChange
        draggable
        pauseOnHover
      />
      <div className="sweet-loading">
        <RingLoader size={100} color={"#123abc"} loading={loaderStatus} />
      </div>
      <NavBar
        currentPage="Notice | Email Master"
        module="notice"
        history={props.history}
      >
        <HeaderBar />
        <Table />
      </NavBar>
    </>
  );
};

export default EmailMaster;
